import PropTypes from "prop-types";
import React from "react";
import { ProposalByProperty } from "rsl-api-106/lib/types";

import { useSession } from "@hooks";

import ProposalBlock from "../ProposalBlock";

type ProposalListProps = {
  proposalsByEtab: ProposalByProperty[];
};

const languagesVarsCodes = [
  "LANG_neobooking_proposal_reserve", //Réserver
  "LANG_neobooking_person", //Personne
  "LANG_neobooking_persons", //Personnes
];

const ProposalList: React.FC<ProposalListProps> = ({ proposalsByEtab }) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <>
      <div className="">
        {(proposalsByEtab as ProposalByProperty[]).map(
          (proposalByEtab: ProposalByProperty, index: number) => {
            return proposalByEtab.proposals && proposalByEtab.property ? (
              <ProposalBlock
                proposals={proposalByEtab.proposals}
                etab={proposalByEtab.property}
                key={`ps_$${index}`}
                proposalActionText={getLanguageVarValue(
                  "LANG_neobooking_proposal_reserve"
                )}
                singlePax={getLanguageVarValue("LANG_neobooking_person")}
                plurialPax={getLanguageVarValue("LANG_neobooking_persons")}
              />
            ) : (
              <></>
            );
          }
        )}
      </div>
    </>
  );
};

ProposalList.propTypes = {
  //
};

export default ProposalList;
